/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Col, Row, Typography } from 'antd';

import RichTextField from '@molecules/RichTextField';
import MediaField from '@organisms/MediaField';
import { TextField, ColorField } from '@molecules';
import { Button } from '@atoms';

import Form from '../Form';

import { PROFILE_FIELDS } from './constant';

const ProfileForm = ({ onSubmit, initialValues: initData, buttons, className, initKey }) => {
  const [form] = Form.useForm(PROFILE_FIELDS);

  const initialValues = React.useMemo(() => form.deserialize(initData), [form, initData]);

  const handleFinish = React.useCallback(
    (value) => {
      onSubmit(value, initData);
      form.resetFields();
    },
    [form, onSubmit, initData],
  );

  return (
    <Form
      onSerializedFinish={handleFinish}
      initialValues={initialValues}
      className={className}
      layout="vertical"
      labelAlign="left"
      colon={false}
      form={form}
    >
      {buttons && <Typography.Text level={3}>Edit Profile</Typography.Text>}
      <Row>
        <Col flex="1">
          <Row>
            <Col flex="1">
              <MediaField {...PROFILE_FIELDS.IMAGE} />
              <TextField {...PROFILE_FIELDS.NAME} />
              <TextField {...PROFILE_FIELDS.TITLE} />
              <TextField {...PROFILE_FIELDS.ORGANISATION} />
              <ColorField {...PROFILE_FIELDS.COLOR} />
              <RichTextField
                {...PROFILE_FIELDS.DESCRIPTION}
                initKey={`${PROFILE_FIELDS.DESCRIPTION.name}-${initKey}`}
              />
            </Col>
          </Row>
          <Row>
            <Col flex="1" gutter={10}>
              {buttons ? (
                buttons({ onSubmit: form.submit })
              ) : (
                <Button type="customBlue" style={{ minWidth: 200 }} onClick={form.submit}>
                  ADD PROFILE
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default ProfileForm;
